module.exports = __webpack_public_path__ + "static/media/banquet_hall.e41ef540.avif";